import { Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useCurrentReport from '../../../hooks/useCurrentReport'
import { useReportingForParam } from '../../../hooks/useReportingForMonth'
import useReports from '../../../hooks/useReports'
import useStages from '../../../hooks/useStages'
import useStagesCount from '../../../hooks/useStagesCount'
import useUpdateReportDoc from '../../../hooks/useUpdateReportDoc'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useStagesFormState } from './hooks/useStagesFormState'
import { StudyHoursSection } from './components/StudyHoursSection'
import { StepsSection47 } from './components/StepsSection47'
import LiveSessions from './components/LiveSessions'
import EssentialsCourses from './components/EssentialsCourses'
import StagesTable from './components/StagesTable'

export const StagesPage = () => {
  const isValidated = useReportMonthGuard()
  const { handleSubmit, update, coreProgramsCounts, user } =
    useStagesFormState()
  const stages = useStages()
  const stagesCount = useStagesCount()
  const report = useCurrentReport()
  const reports = useReports()
  const reportingFor = useReportingForParam()
  const updateReport = useUpdateReportDoc()
  const purpleBubbleContent = usePurpleBubblesText('Step-12')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  if (!user) return null

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={8}>
        <MonthlyReportHeader title={`Core Education & ${stagesCount} Steps`} />
        {purpleBubbleContent?.text && (
          <PurpleBubbleContent text={purpleBubbleContent.text} />
        )}
        <LiveSessions
          reports={reports}
          month={reportingFor}
          update={updateReport}
          coreProgramsCounts={coreProgramsCounts}
        />
        <StudyHoursSection report={report} updateReport={updateReport} />

        <EssentialsCourses editable={true} user={user} />

        <StepsSection47 stages={stages || []} stagesCount={stagesCount} />

        <StagesTable update={update} user={user} />

        <MonthlyReportNavButtons />
      </Stack>
    </form>
  )
}
